export default "__VITE_ASSET__8ab95c17__"